<template>
    <div class="contacts" :class="{loading: loading}">
        <fieldset>
            <legend class="no-margin">
                Contact Restrictions
            </legend>

            <ul class="list-group">
                <li class="list-group-item"
                    v-for="matchedContact in matchedContacts">

                    <div class="pull-right">
                        <button type="button" :disabled="loading" class="btn btn-sm btn-primary"
                                @click="toggleContactRestriction(matchedContact)"
                                v-if="matchedContact.id && !matchedContact.deleted_at">
                            Un-restrict
                        </button>
                        <button v-else type="button" :disabled="loading" class="btn btn-sm btn-warning"
                                @click="toggleContactRestriction(matchedContact)">
                            Restrict
                        </button>
                    </div>

                    <h4 v-if="matchedContact.contact.includes('@')">
                        {{matchedContact.contact}}
                    </h4>
                    <h4 v-else>
                        {{matchedContact.contact | displayPhone}}
                    </h4>
                </li>
            </ul>
        </fieldset>
    </div>
</template>

<script>
    export default {
        props: {
            contacts: {
                required: true,
                type: Array,
            },
        },

        data(){
            return {
                loading: true,

                contactRestrictions: [],
            };
        },

        mounted(){
            return this.init();
        },

        watch: {},

        computed: {
            /**
             * Returns an array of either the matching contactRestriction record (including archived) or the contact
             * in an object wrapper
             * @returns {*}
             */
            matchedContacts(){
                const contactRestrictions = this.contactRestrictions;

                return _.reduce( this.contacts, ( carry, contact ) => {
                    let contactRestriction = _.find( contactRestrictions, { contact: contact } );

                    if( contactRestriction ){
                        carry.push( contactRestriction );
                    }
                    else{
                        carry.push( {
                            contact: contact
                        } );
                    }

                    return carry;
                }, [] );
            }
        },

        methods: {
            init(){
                return this.loadContactRestrictions()
                    .finally( () => {
                        this.loading = false;
                    } );
            },

            loadContactRestrictions(){
                if( !this.contacts ){
                    throw new Error( 'No company ID specified' );
                }

                var url = '/api/contactRestrictions?archived=true&';
                _.each( this.contacts, ( contact, index ) => {
                    url += 'or[' + index + '][contact]=' + encodeURI( contact ) + '&';
                } );

                return axios.get( url )
                    .then( ( response ) => {
                        this.$set( this, 'contactRestrictions', response.data.ContactRestrictions );
                    } );
            },

            toggleContactRestriction( matchedContact ){
                if( matchedContact.id && matchedContact.deleted_at ){
                    this.restoreContactRestriction( matchedContact );
                }
                else if( matchedContact.id && !matchedContact.deleted_at ){
                    this.archiveContactRestriction( matchedContact );
                }
                else {
                    this.createContactRestriction( matchedContact.contact );
                }
            },

            createContactRestriction( contact ){
                this.loading = true;
                return axios.post( '/api/contactRestrictions', {
                    ContactRestriction: {
                        contact: contact
                    }
                } )
                    .then( () => {
                        this.$notify( {
                            type: 'success',
                            placement: 'top-left',
                            title: 'Restricted ' + contact,
                        } );
                    } )
                    .finally( () => {
                        this.init();
                    } )
                    .catch( this.$root.handleErrors );
            },

            archiveContactRestriction( contactRestriction ){
                this.loading = true;
                return axios.delete( '/api/contactRestrictions/' + contactRestriction.id )
                    .then( () => {
                        this.$notify( {
                            type: 'success',
                            placement: 'top-left',
                            title: 'Unrestricted ' + contactRestriction.contact,
                        } );
                    } )
                    .finally( () => {
                        this.init();
                    } )
                    .catch( this.$root.handleErrors );
            },

            restoreContactRestriction( contactRestriction ){
                this.loading = true;
                return axios.put( '/api/contactRestrictions/' + contactRestriction.id + '/restore' )
                    .then( () => {
                        this.$notify( {
                            type: 'success',
                            placement: 'top-left',
                            title: 'Restricted ' + contactRestriction.contact,
                        } );
                    } )
                    .finally( () => {
                        this.init();
                    } )
                    .catch( this.$root.handleErrors );
            },

            resetData(){
                Object.assign( this.$data, this.$options.data() );
            },

            afterSave(){
                this.init();
            },
        }
    }
</script>
